import PropTypes from 'prop-types';
import styles from './baseLayout.module.css';
import Nav from '../../components/Nav/Nav';

function BaseLayout({ children, header = false, headerLogo, versionRoute, onVersionChange, goBack, sidebar, fitHeight, title, fullWidth }) {
  return (
    <>
      {header && (
        <Nav
          logo={headerLogo}
          versionRoute={versionRoute}
          onVersionChange={onVersionChange}
          goBack={goBack}
          sidebar={sidebar}
          label={title}
        />
      )}
      <div data-header={header} data-full-width={fullWidth} className={styles.container}>
        <div data-fit-height={fitHeight} className={styles.content}>
          {children}
        </div>
      </div>
    </>
  );
}

BaseLayout.propTypes = {
  children: PropTypes.node.isRequired,
  header: PropTypes.bool,
  headerLogo: PropTypes.bool,
  versionRoute: PropTypes.string,
  onVersionChange: PropTypes.func,
  goBack: PropTypes.bool,
  sidebar: PropTypes.bool,
  fitHeight: PropTypes.bool,
  title: PropTypes.string,
};

export default BaseLayout;